/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Download_AllInputs */

const en_doc_download_all = /** @type {(inputs: Doc_Download_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download all`)
};

const pt_br2_doc_download_all = /** @type {(inputs: Doc_Download_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixar todos`)
};

/**
* | output |
* | --- |
* | "Download all" |
*
* @param {Doc_Download_AllInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_download_all = /** @type {((inputs?: Doc_Download_AllInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Download_AllInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_download_all(inputs)
	return pt_br2_doc_download_all(inputs)
});